import { USER_PERMISSIONS_CATEGORIES } from "common/constants";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { typedObjectEntries } from "common/helpers/utils";
import type { UserPermissions } from "common/types";

import type { ReactNode } from "react";

//the permissions provided here are checked
export type RestrictedComponentProps =
  | {
      visibleFor: UserPermissions | "full" | "owner";
      children: ReactNode;
    }
  | {
      enabledFor: UserPermissions | "full" | "owner";
      children: (isDisabled: boolean) => ReactNode;
    };

export default function RestrictedComponent(props: RestrictedComponentProps) {
  const { permissions, role } = useSelectedWorkspaceContext();

  const restriction =
    "enabledFor" in props ? props.enabledFor : props.visibleFor;

  let hasAccess: boolean;

  if (restriction === "full") {
    hasAccess = typedObjectEntries(USER_PERMISSIONS_CATEGORIES)
      .filter(([, { permissionOptions }]) => !!permissionOptions.length)
      .every(([key]) => permissions.includes(`${key}_full`));
  } else if (restriction === "owner") {
    hasAccess = role === "owner";
  } else {
    hasAccess = restriction.every(
      (requiredPermission) =>
        permissions.includes(requiredPermission) ||
        //if the required permission is limited, full permission passes
        (requiredPermission.endsWith("_limited")
          ? permissions.includes(
              requiredPermission.replace(
                "_limited",
                "_full",
              ) as UserPermissions[number],
            )
          : false),
    );
  }

  if ("enabledFor" in props) {
    return props.children(!hasAccess);
  }

  return hasAccess ? props.children : null;
}
